export default __webpack_public_path__ + "static/media/amico.3d5ce9f1.svg";